// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"847":"bede50eb","3293":"055eee52"}[chunkId] + ".chunk.css";
};